export default __webpack_public_path__ + "static/APP_4_1-5a6820b307d613a27868e12c40d3988e.png";